import renderItemNode from './renderitemnode.js';
import triggerOne from '../../trigger/_triggerone.js';
import checkAlreadyRendered from './checkalreadyrendered.js';
// this function renders inserted items if possible when unshift or push method is called
export default function processUnshift(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions,
    container = _ref.container;
  var added = eventOptions.added,
    silent = eventOptions.silent;
  // iterate over all added items in opposite order
  for (var i = added.length - 1; i + 1; i--) {
    var item = added[i];
    if (item && typeof item === 'object') {
      // if a node of an item is already rendered then throw an error
      checkAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      var _renderItemNode = renderItemNode({
          selfDef: selfDef,
          self: self,
          item: item,
          eventOptions: eventOptions
        }),
        node = _renderItemNode.node,
        itemEventOptions = _renderItemNode.itemEventOptions;
      if (node) {
        if (container.firstChild) {
          container.insertBefore(node, container.firstChild);
        } else {
          container.appendChild(node);
        }
        if (!silent) {
          triggerOne(item, 'afterrender', itemEventOptions);
        }
      }
    }
  }
}